import { FileText } from "lucide-react";
import { useTranslations } from "next-intl";
import type { ReactNode } from "react";

export function HeroVorgangAttachment(props: {
  readonly fileName: string;
}): ReactNode {
  const t = useTranslations("marketing.heroVorgangAttachment");
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "12px 14px",
        background: "#fff",
        border: "1px solid #ECEDF0",
        borderRadius: 12,
        maxWidth: "78%",
        alignSelf: "flex-start",
      }}
    >
      <span
        style={{
          width: 40,
          height: 40,
          borderRadius: 8,
          background: "#FEF2F2",
          color: "#DC2626",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <FileText width={20} height={20} strokeWidth={1.8} />
      </span>
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: "rgba(11,15,25,0.45)",
          }}
        >
          {t("pdf")}
        </div>
        <div
          style={{
            fontSize: 13,
            fontWeight: 600,
            color: "#0B0F19",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {props.fileName}
        </div>
      </div>
    </div>
  );
}
